export function getActiveElements(link: string): string {
    const url = window.location.pathname;
    if (link === "dashboard") {
        if (url.includes("offer") || url.includes("legal-request")) {
            return "layout__sidebar-nav-link_active";
        }
    }

    if (link === "upcoming-calls" || link === "book-new-calls") {
        if (url.includes("follow-ups") || url.includes("upcoming-calls")) {
            return "layout__sidebar-nav-link_active";
        }
    }


    if (link === "/settings/history") {
        if (url.includes("checkout")) {
            return "layout__sidebar-nav-link_active";
        }
    }

    return ""
}